<div class="dialog-backdrop" *ngIf="isVisible" (click)="handleBackdropClick($event)">
  <div class="otp-validation-dialog">
    <!-- Header Section -->
    <div class="dialog-header">
      <h2 class="dialog-title">{{ title }}</h2>
      <p class="dialog-description">{{ description }}</p>
    </div>

    <!-- Form Section -->
    <div class="dialog-body">
      <form (ngSubmit)="handleSubmit()" class="form-groups">
        <!-- OTP Input -->
        <div class="form-group">
          <label for="otp" class="form-label">
            OTP
          </label>
          <input
            type="text"
            id="otp"
            name="otp"
            class="form-input"
            [value]="otp"
            (input)="onOtpInput($event)"
            placeholder="Enter OTP"
            maxlength="6"
            required
            [attr.aria-required]="true"
            autocomplete="off"
          />
        </div>
      </form>
    </div>

    <!-- Actions Section -->
    <div class="dialog-actions">
      <button 
        type="button"
        [class.btn-primary]="isFormValid()"
        [class.btn-disabled]="!isFormValid()"
        [disabled]="!isFormValid() || isSubmitting"
        (click)="handleSubmit()">
        {{ isSubmitting ? 'Submitting...' : 'Submit' }}
      </button>
      <button 
        type="button"
        class="btn-secondary"
        (click)="handleCancel()">
        Cancel
      </button>
    </div>
  </div>
</div>
